module.exports = __webpack_public_path__ + "img/product-shot_06_loading.28d9c472.jpg";